import {makeAutoObservable} from "mobx";
import axios, {GenericAbortSignal} from "axios";
import {api} from "../../api/endpoints";
import AppStore from "../../app.store";
import {FirebaseModel} from "./firebase.model";
import uuid from "react-uuid";

const usersInitialState: FirebaseModel[] = [];

class FirebaseStore {
    public firebaseapi ?: FirebaseModel[] | undefined = usersInitialState;
    public firebaseTotal = 0;
    public popupSuppressCount = 0;
    public popupEnabled = true;

    public firebasePageInit = async (signal: GenericAbortSignal) => {
        const {getFirebase} = await import('../../firebase.loader');
        const firebase = await getFirebase();
        await firebase.firebaseInit();
        await this.firebaseReq({signal, limit: 10, offset: 0, append: false});
    }

    constructor() {
        makeAutoObservable(this);
        try {
            const stored = localStorage.getItem('visor-popup-notifications');
            if (stored !== null) {
                this.popupEnabled = stored === 'true';
            }
        } catch (err) {
            // ignore localStorage errors
        }
    }

    public setPopupEnabled = (enabled: boolean) => {
        this.popupEnabled = enabled;
        try {
            localStorage.setItem('visor-popup-notifications', String(enabled));
        } catch (err) {
            // ignore localStorage errors
        }
    }

    public suppressPopups = () => {
        this.popupSuppressCount += 1;
    }

    public restorePopups = () => {
        this.popupSuppressCount = Math.max(0, this.popupSuppressCount - 1);
    }

    public get isPopupSuppressed() {
        return this.popupSuppressCount > 0;
    }

    setFirebase(data: FirebaseModel[]) {
        this.firebaseapi = data;
    }

    setFirebaseTotal(total: number) {
        this.firebaseTotal = total;
    }

    sendNotesIds = async (ids: number[]) => {
        if (!ids?.length) {
            return;
        }
        try {
            const {getToken} = AppStore

            const headers = {
                Authorization: 'Bearer ' + getToken()!,
            }
            const payload = {
                id: ids
            }
        await axios.put(api.put_notifications, payload, {headers});
      //  this.firebaseReq()
        } catch (err) {
            console.error(err);
        }
    }
    
    public firebaseReq = async (params?: {
        signal?: GenericAbortSignal;
        limit?: number;
        offset?: number;
        onlyUnread?: boolean;
        append?: boolean;
    }) => {
        try {
            const {getToken} = AppStore

            const headers = {
                Authorization: 'Bearer ' + getToken()!,
            }

            const limit = params?.limit ?? 10;
            const offset = params?.offset ?? 0;
            const onlyUnread = params?.onlyUnread ?? false;
            const query = new URLSearchParams({
                limit: String(limit),
                offset: String(offset),
                only_unread: String(onlyUnread)
            });
            const response = await axios.get(`${api.notifications}?${query.toString()}`, {headers, signal: params?.signal});
            const items = response.data.items ?? [];
            const total = response.data.total ?? 0;
            if (params?.append && this.firebaseapi?.length) {
                this.setFirebase([...this.firebaseapi, ...items]);
            } else {
                this.setFirebase(items);
            }
            this.setFirebaseTotal(total);
        } catch (err) {
        }
    }

    public markAllRead = async () => {
        try {
            const {getToken} = AppStore

            const headers = {
                Authorization: 'Bearer ' + getToken()!,
            }
            await axios.put(`${api.put_notifications}?all=true`, {}, {headers});
        } catch (err) {
            console.error(err);
        }
    }

    public registerNotificationToken = async (token: string) => {
        try {
            const {getToken} = AppStore

            const headers = {
                Authorization: 'Bearer ' + getToken()!,
            }

            let device_uuid = localStorage.getItem('device_uuid')
            if (!device_uuid) {
                device_uuid = uuid();
                localStorage.setItem("device_uuid", device_uuid);
            }

            const payload = {
                token: token,
                device_uuid: device_uuid,
            }

            const response = await axios.post(api.register_notification_token, payload, {headers});
        } catch (err) {
            console.error("registerNotificationToken error", err);
        }
    }

    public unregisterNotificationToken = async (token?: string) => {
        try {
            const {getToken} = AppStore

            const headers = {
                Authorization: 'Bearer ' + getToken()!,
            }

            const device_uuid = localStorage.getItem('device_uuid')
            const payload = {
                token: token ?? '',
                device_uuid: device_uuid,
            }

            await axios.delete(api.register_notification_token, {headers, data: payload});
        } catch (err) {
            console.error("unregisterNotificationToken error", err);
        }
    }

    // public getNotifications = () => {
    //     console.log("firebaseReq start")
    //
    //     try {
    //         const {getToken} = AppStore
    //
    //         const headers = {
    //             Authorization: 'Bearer ' + getToken()!,
    //         }
    //
    //         const response = axios.get(api.get_notifications , {headers, signal});
    //         this.setFirebase(response.data.resp);
    //     } catch (err) {
    //         console.error(err);
    //     }
    // }
}

export default new FirebaseStore();